import { Component, h, Prop, Host } from '@stencil/core';
import { align_center } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-product-card-info',
  styleUrl: 'pn-product-card-info.scss',
})
export class PnProductCardInfo {
  @Prop() rulle: string;
  @Prop() paket: string;
  @Prop() label: string;
  @Prop() text: string;

  render() {
    return this.label ? (
      <Host>
        <div class="cardinfocontent">{this.text ? <pre slot="formatPre">{this.text}</pre> : null}</div>
      </Host>
    ) : (
      <Host>
        <div class="cardinfocontent">
          {this.paket ? (
            <div class="cardinfocontent-item">
              <strong>Maxmått</strong>
              {this.paket.split('/').map(item =>
                item.split(':').length > 1 ? (
                  <p>
                    <strong>{item.split(':')[0] + ': '}</strong> {item.split(':')[1]}
                  </p>
                ) : (
                  <p>{item}</p>
                ),
              )}
            </div>
          ) : null}
          {this.rulle ? (
            <div class="cardinfocontent-item">
              <strong>Rulle</strong>
              {this.rulle.split('/').map(item =>
                item.split(':').length > 0 ? (
                  <p>
                    <strong>{item.split(':')[0] + ': '}</strong> {item.split(':')[1]}
                  </p>
                ) : (
                  <p>{item}</p>
                ),
              )}
            </div>
          ) : null}
        </div>
      </Host>
    );
  }
}
<pn-icon icon={align_center} small="false" color="black" />;
